export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative w-full min-h-screen flex flex-col overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          alt="Aerial drone view of the Great Barrier Reef near Bedarra Island, Mission Beach Queensland"
          className="w-full h-full object-cover object-center"
          width={1920}
          height={1080}
          src="https://storage.readdy-site.link/project_files/c46f7f07-593f-4f17-9a57-3ac86083c18c/8a744d67-edcc-461c-a00f-cff00962dcb2_DJI_0125.jpg?v=75d888a170cc561f6e9c0beb2c51d415"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center text-center px-6 md:px-10 pt-24 pb-10 w-full">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-cyan-400/40 bg-cyan-400/10 backdrop-blur-sm mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 animate-pulse"></span>
          <span className="text-cyan-300 text-[11px] uppercase tracking-[3px] font-medium">For Bedarra Island Resort Guests</span>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-[5.5rem] font-black text-white leading-[1.0] max-w-5xl mb-6 tracking-tight">
          The Reef Is<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 to-teal-300">Right There.</span>
        </h1>

        <p className="text-base md:text-xl text-white/85 max-w-2xl leading-relaxed mb-10 font-light">
          You've chosen one of Australia's most extraordinary island escapes. Now add the world beneath the surface — pristine outer reef, untouched coral gardens, and marine life most people only see in documentaries.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mb-14">
          <a
            href="https://wa.me/61455957263?text=Hi!%20I'd%20like%20to%20book%20a%20dive%20trip%20to%20Bedarra%20Island."
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2.5 px-8 py-4 rounded-full bg-gradient-to-r from-orange-500 to-amber-500 text-white font-bold text-base cursor-pointer hover:scale-105 transition-transform duration-300"
          >
            <i className="ri-ship-2-line text-lg w-5 h-5 flex items-center justify-center"></i>
            Book Your Dive Day Trip
          </a>
          <a
            href="tel:0455957263"
            className="whitespace-nowrap inline-flex items-center justify-center gap-2.5 px-8 py-4 rounded-full border-2 border-white/60 text-white font-medium text-base cursor-pointer hover:bg-white/15 hover:border-white transition-all duration-300"
          >
            <i className="ri-phone-line text-lg w-5 h-5 flex items-center justify-center"></i>
            Call: 0455 957 263
          </a>
        </div>

        <div className="flex items-center gap-2 mb-8">
          <div className="flex items-center gap-0.5">
            {[...Array(5)].map((_, i) => (
              <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
            ))}
          </div>
          <span className="text-white/70 text-sm font-light">
            <strong className="text-white font-semibold">4.8</strong> · 249 reviews
          </span>
        </div>

        <div className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-x-5 gap-y-2 text-white/50 text-[11px] uppercase tracking-widest">
          <span className="whitespace-nowrap flex items-center gap-1.5"><i className="ri-award-line text-cyan-400/70"></i>PADI Dive Centre</span>
          <span className="hidden sm:inline text-white/20">·</span>
          <span className="whitespace-nowrap flex items-center gap-1.5"><i className="ri-ship-line text-cyan-400/70"></i>MV Mahi-Mahi</span>
          <span className="hidden sm:inline text-white/20">·</span>
          <span className="whitespace-nowrap flex items-center gap-1.5"><i className="ri-map-pin-line text-cyan-400/70"></i>Clump Point Jetty, Mission Beach</span>
          <span className="hidden sm:inline text-white/20">·</span>
          <span className="whitespace-nowrap flex items-center gap-1.5"><i className="ri-compass-3-line text-cyan-400/70"></i>Outer Reef Specialists</span>
        </div>
      </div>

      {/* Scroll down */}
      <div className="relative z-10 flex justify-center pb-8">
        <button
          aria-label="Scroll down"
          onClick={() => scrollTo('#about')}
          className="flex flex-col items-center gap-1 text-white/40 hover:text-white/70 transition-colors cursor-pointer group"
        >
          <span className="text-[10px] uppercase tracking-widest">Explore</span>
          <i className="ri-arrow-down-line text-xl w-6 h-6 flex items-center justify-center animate-bounce"></i>
        </button>
      </div>
    </section>
  );
}
